import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useRef, useState } from 'react';

const ImagePreviewContext = createContext();

export const ImagePreviewProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const modalRef = useRef(null);

  useEffect(() => {
    const modal = modalRef.current;
    if (!modal) return;

    const handleModalTransitionEnd = () => {
      if (!isOpen) {
        setPreviewImage(null);
      }
    };

    modal.addEventListener('transitionend', handleModalTransitionEnd);
    return () => {
      modal.removeEventListener('transitionend', handleModalTransitionEnd);
    };
  }, [isOpen]);

  const openImagePreview = (imageSrc, imageAlt) => {
    setPreviewImage({ src: imageSrc, alt: imageAlt });
    setIsOpen(true);
  };

  const closeImagePreview = () => {
    setIsOpen(false);
  };

  const modalState = {
    isOpen,
    previewImage,
    modalRef,
    openImagePreview,
    closeImagePreview,
  };

  return (
    <ImagePreviewContext.Provider value={modalState}>
      {children}
    </ImagePreviewContext.Provider>
  );
};

ImagePreviewProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useImagePreview = () => {
  const context = useContext(ImagePreviewContext);
  if (!context) {
    throw new Error('useImagePreview must be used within ImagePreviewProvider');
  }
  return context;
};
